import React, { forwardRef, useCallback, useImperativeHandle, useState } from "react";
import styles from "./AddAppliancesForm.module.scss";
import FindAppliances from "./components/FindAppliances";
import ApplianceOverview from "./components/appliance-overview/ApplianceOverview";
import { Appliance } from "../../../../../model/appliance";
import { ApplianceItem } from "../../../../../model/solar-recommendation-form/appliance-item";

type Props = {
	initialAppliances: ApplianceItem[];
	addAppliances: (appliances: ApplianceItem[]) => void;
	// onSaveAndContinue: (appliances: ApplianceItem[]) => void;
};

const AddAppliancesForm = forwardRef<{ saveAndContinue: () => void }, Props>((props, ref) => {
	const { initialAppliances = [], 
        addAppliances } = props;

	const [appliances, setAppliances] = useState<ApplianceItem[]>(structuredClone(initialAppliances));

	const [addingNewAppliance, setAddingNewAppliance] = useState<boolean>(false);
	const [ totalAppliancesCount, setTotalAppliancesCount] = useState<number>(0);
	const [applianceToChange, setApplianceToChange] = useState<ApplianceItem | undefined>(undefined);

	const saveAndContinue = useCallback(() => {
		appliances.forEach(appliance => {
			appliance.editingProps = {
				editing: false,
				dailyUsage: undefined,
				newAppliance: undefined,
				quantity: undefined,
			};
		});

		 addAppliances(appliances)
	}, [appliances, addAppliances]);

	useImperativeHandle(ref, () => ({
		saveAndContinue,
	}));

	function triggerFindAppliance(appliance: ApplianceItem | undefined) {
		setAddingNewAppliance(true);
		setApplianceToChange(appliance);
	}

	function onChangeAppliances(newAppliances: ApplianceItem[]) {
		setAppliances(newAppliances);
	}

	function findMaxId() {
		return appliances.length > 0 ? Math.max(...appliances.map(a => a.id)) : 0;
	}

	function addAppliancesToForm(a: Appliance[]) {
		let maxId = findMaxId();

		let newAppliances: ApplianceItem[] = a.map(appliance => {
			maxId++;
			return {
				id: maxId,
				appliance: appliance,
				dailyUsage: 1,
				quantity: 1,
				editingProps: {
					editing: false,
				},
			};
		});

		setAppliances([...appliances, ...newAppliances]);
		setAddingNewAppliance(false);
	}

	function passSelectedAppliancesFindAppliance() {
		return appliances.map(applianceItem => applianceItem.appliance);
	}

	function passOptionalPropsToFindAppliances() {
		if (!applianceToChange) {
			return {
				addApplianceProps: {
					onAddAppliances: addAppliancesToForm,
				},
			};
		} else {
			return {
				editApplianceProps: {
					applianceToChange: applianceToChange,
					onEditAppliance: (appliance: ApplianceItem) => {
						const newAppliances = appliances.map(a => (a.id === appliance.id ? appliance : a));

						setAppliances(newAppliances);
						setAddingNewAppliance(false);
					},
				},
			};
		}
	}

	return (
		<div className={styles.container}>
			{addingNewAppliance ? (
				<FindAppliances
					selectedAppliancesFromBefore={passSelectedAppliancesFindAppliance()}
					onBack={() => setAddingNewAppliance(false)}
					onGetApplianceCount={setTotalAppliancesCount}
					{...passOptionalPropsToFindAppliances()}
				/>
			) : (
				<ApplianceOverview onBack={() => {}} onSave={saveAndContinue} appliances={appliances} isVisibleButton={totalAppliancesCount != appliances.length} onChange={onChangeAppliances} onFindAppliance={triggerFindAppliance} />
			)}
		</div>
	);
});

export default AddAppliancesForm;
